import React from 'react';
import { useSelector } from 'react-redux';
import { SelectField } from 'components';
import { FormControl, ListSubheader } from '@mui/material';
import { OPTIONS, MENU_ITEMS_CONFIG } from './Constants';

const OptionSelector = ({ onChange, value }) => {
	const role = useSelector(state => state.session.user.role);
	const projects = useSelector(state => state.session.user.projects);

	const hasItemAccess = (item) => {
		const hasRole = item.allowedRoles.includes(role);
		const hasProject = Array.isArray(projects) && projects.some(p => item.allowedProjects.includes(p));
		return hasRole && hasProject;
	};

	const visibleItems = MENU_ITEMS_CONFIG.filter(hasItemAccess);

	// Group visible items by project
	const grouped = visibleItems.reduce((acc, item) => {
		if (!acc[item.project]) acc[item.project] = [];
		acc[item.project].push(item);
		return acc;
	}, {});

	// Build menuItems with subheaders injected as non-selectable items
	const menuItems = [
		{ value: OPTIONS.NONE, disabled: true, text: 'Select one option' },
		...Object.entries(grouped).flatMap(([projectName, items]) => [
			{ value: `__header__${projectName}`, disabled: true, text: projectName, isHeader: true },
			...items.map(item => ({ value: item.value, disabled: false, text: `  ${item.text}` })),
		]),
	];

	return (
		<FormControl fullWidth>
			<SelectField
				id="inputType"
				name="inputType"
				value={value}
				onChange={(e) => onChange(e.target.value)}
				hintText="Option"
				menuItems={menuItems}
			/>
		</FormControl>
	);
};

export default OptionSelector;